import { orchestrator } from 'satcheljs';
import resetSearch from '../actions/resetSearch';
import getStore from '../store/store';
import logFailedSearchTerm from '../utils/logFailedSearchTerm';
import setQuery from '../mutators/setQuery';
export default orchestrator(resetSearch, function (message) {
    var successfulSearch = message.successfulSearch;
    if (!successfulSearch) {
        logFailedSearchTerm(getStore().query);
    }
    setQuery('', false);
});
//# sourceMappingURL=onResetSearch.js.map